import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { IPetsyCanvasConfettiProps } from './PetsyCanvasConfetti.types';
import './PetsyCanvasConfetti.scss';
import Fireworks from "react-canvas-confetti/dist/presets/fireworks";

export default function PetsyCanvasConfetti(props: IPetsyCanvasConfettiProps) {
  const [intervalId, setIntervalId] = useState<any>();
  const controller = useRef<any>(null);

  const onInitHandler = ({ conductor }) => {
    controller.current = conductor;
  };

  useEffect(() => {
    if (props.run) {
      startAnimation();
    }
  }, [props.run]);

  const startAnimation = useCallback(() => {
    if (!intervalId && controller.current) {
      setIntervalId(setInterval(() => {
        controller.current.run({ speed: 2 });
      }, 1000));
      setTimeout(pauseAnimation, 4000);
    }
  }, [intervalId]);

  const pauseAnimation = useCallback(() => {
    clearInterval(intervalId);
    setIntervalId(null);
    console.log('pauseAnimation', controller);
    if (controller.current) {
      controller.current.stop();
    }
  }, [intervalId]);

  const stopAnimation = useCallback(() => {
    clearInterval(intervalId);
    setIntervalId(null);
    if (controller.current) {
      controller.current.stop();
    }
  }, [intervalId]);

  useEffect(() => {
    return () => {
      clearInterval(intervalId);
    };
  }, [intervalId]);

  return (
    <div>
      <Fireworks onInit={onInitHandler} />
    </div>
  );
}
